import React, { useState } from "react";
import { CircularProgress, DialogContent, Typography } from "@mui/material";
import CommonButtons from "../CommonButtons";
import { ModalWrapper } from "src/shared/components/ModalWrapper";

export interface ConfirmDialogProps {
  open: boolean;
  title: string;
  loading?: boolean;
  description: string;
  confirmLabel?: string;
  cancelLabel?: string;
  isProcessing?: boolean;
  disableConfirm?: boolean;
  onConfirm: () => Promise<void> | void;
  onCancel: () => void;
}

const ConfirmDialog: React.FC<ConfirmDialogProps> = ({ open, title, description, confirmLabel = "Confirm", cancelLabel = "Cancel", isProcessing = false, disableConfirm = false, onConfirm, onCancel,}) => {
  const [clicked, setClicked] = useState(false);

  if (!open) return null;

  const handleConfirm = async () => {
    if (clicked) return; // 🔒 prevent double click

    setClicked(true);
    try {
      await onConfirm();
    } finally {
      // reset only if modal stays open
      setClicked(false);
    }
  };

  const isDisabled = clicked || isProcessing || disableConfirm;

  return (
    <ModalWrapper title={title} onClose={onCancel} showCloseButton width="max-w-lg">
      {/* Body */}
      <DialogContent sx={{ py: 3 }}>
        <Typography variant="body1" className="mb-6" style={{ fontFamily: "inherit" }}>
          {description}
        </Typography>
      </DialogContent>

      {/* Actions */}
      <div className="flex justify-end items-center gap-3">
        <CommonButtons className="w-32 h-10" label={cancelLabel} variant="outlineDanger" onClick={onCancel} disabled={isDisabled} />

        <CommonButtons className="w-32 h-10" label={ isDisabled ? (
              <div className="flex items-center justify-center gap-2">
                <CircularProgress size={18} />
                Processing
              </div>
            ) : (
              confirmLabel
            )
          }
          onClick={handleConfirm}
          disabled={isDisabled}
        />
      </div>
    </ModalWrapper>
  );
};

export default ConfirmDialog;
